import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "penhaus_token";

// In-memory fallback so auth still works if localStorage is unavailable
// (private mode, embedded webviews, blocked third-party storage, etc.)
let memoryToken = null;

export const getToken = () => {
  if (memoryToken) return memoryToken;
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return memoryToken;
  }
};

export const setToken = (t) => {
  if (!t) return;
  memoryToken = t;
  try {
    localStorage.setItem(TOKEN_KEY, t);
  } catch {
    /* ignore — keep in memory */
  }
};

export const clearToken = () => {
  memoryToken = null;
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
};

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach Bearer token (primary auth — robust across preview/deploy domains where
// third-party/SameSite cookies can be dropped). Cookies remain as a fallback.
api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(r.result);
    r.onerror = reject;
    r.readAsDataURL(file);
  });
}

export async function uploadImage(file) {
  const dataUrl = await fileToDataUrl(file);
  const { data } = await api.post("/upload", { image_base64: dataUrl, filename: file.name });
  return data; // {path, url}
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
